import axios from "axios";

// Prefer SAME-ORIGIN API calls in the browser so the app works on any host
// (preview URL, surveys2cad.com, custom domains) without a rebuild. Falls back
// to REACT_APP_BACKEND_URL only during server-side rendering / tests.
const runtimeOrigin =
    typeof window !== "undefined" && window.location && window.location.origin
        ? window.location.origin
        : "";
const BACKEND_URL =
    runtimeOrigin || process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const fetchLeads = () => api.get("/leads").then((r) => r.data);
export const fetchServices = () => api.get("/services").then((r) => r.data.services);
export const fetchServiceDetail = (slug) => api.get(`/services/${slug}`).then((r) => r.data);
export const fetchStates = () => api.get("/states").then((r) => r.data.states);
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data.testimonials);
export const fetchCaseStudies = () => api.get("/case-studies").then((r) => r.data.case_studies);
export const fetchBlogPosts = () => api.get("/blog-posts").then((r) => r.data.posts);
export const fetchBlogPost = (slug) => api.get(`/blog-posts/${slug}`).then((r) => r.data);
export const estimateQuote = (payload) => api.post("/quote-estimate", payload).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const submitInquiry = (payload) => api.post("/inquiry", payload).then((r) => r.data);
